import Balance from "ui/wallet/component/display/Balance/Balance";
import { BalanceProps } from "ui/wallet/component/display/Balance/Balance.types";
import clsx from "clsx";
import usePointsBalance from "./hooks/usePointsBalance";
import { default as config } from "common/config/config";
import { ModalProps, Row } from "@commonlibs";
import { spacing } from "ui/config/theme/spacing/spacing";
import { ModalWithId, useModal } from "commonlibs/react-components-core";
import { SendPointsToUserModalProps } from "ui/point/containers/SendPointsToUserModal/SendPointsToUserModal.types";
import EditIcon from "ui/common/icons/EditIcon";
import useUserState from "ui/adapter/state/useUserState";
import { RoleType } from "common/models/role/Role";

export interface PointsBalanceActionsProps extends Omit<BalanceProps, "units" | "balance"> {
    className?: string;
    style?: React.CSSProperties;
    showUnits?: boolean;
    balance: string | undefined;
    modal: ModalWithId<ModalProps & SendPointsToUserModalProps>;
    gab?: string;
}

export default function PointsBalanceActions({
    className,
    showUnits,
    balance: balanceProp = "0",
    isLoading: isLoadingProp,
    modal,
    gab,
    ...rest
}: PointsBalanceActionsProps) {
    const props = usePointsBalance({ balance: balanceProp, isLoading: isLoadingProp });
    const { showModal } = useModal();
    const { selectedRole } = useUserState();

    return (
        <Row justifyContent="flex-start" gap={gab ? gab : spacing["2.5"]}>
            <Balance
                className={clsx("points-balance", className)}
                units={showUnits ? config.tokenNames.points : undefined}
                {...props}
                {...rest}
            />
            {selectedRole?.roleType === RoleType.ORGANIZATION_OWNER ? (
                <EditIcon css={{ cursor: "pointer" }} fontSize={20} onClick={() => showModal(modal)} />
            ) : null}
        </Row>
    );
}
